import ToolkitProvider, { Search } from 'react-bootstrap-table2-toolkit'
import { useSelector } from 'react-redux'

import { CustomWindow, Table } from '../../../../../components'
import {
  onSortDocument,
  onSortNumber
} from '../../../../../components/Table/sort'
import mapWithRelationship from '../../../../../lib/detectRelationship'
import { selectRelateds } from '../../../../../redux/selectors/relateds'
import {
  formatDocument,
  hashObject,
  isCypheredDocument,
  isPending,
  onlyNumbers
} from '../../../../../utils'

const { SearchBar } = Search

export default function TrabalhoEscravo ({ data, error, loaded }) {
  const relateds = useSelector(selectRelateds)

  const name = 'bandeiraAmarela.trabalhoEscravo'
  const title = 'Trabalho escravo'

  if (isPending({ error, loaded })) {
    return (
      <CustomWindow title={title} name={name}>
        <div />
      </CustomWindow>
    )
  }

  if (error) {
    return (
      <CustomWindow title={title} name={name} defaultOpen>
        <div>Ops! Aconteceu um erro ao carregar trabalho escravo</div>
      </CustomWindow>
    )
  }

  return (
    <CustomWindow title={title} name={name}>
      <ToolkitProvider
        keyField='id'
        search
        columns={[
          { dataField: 'empregador', text: 'Nome', sort: true },
          {
            dataField: 'relationship',
            text: 'Grau'
          },
          {
            dataField: 'document',
            text: 'Documento',
            sort: true,
            sortFunc: onSortDocument,
            searchable: false
          },
          { dataField: 'rawDocumento', hidden: true },
          {
            dataField: 'trabalhadoresEnvolvidos',
            text: 'Trabalhadores envolvidos',
            sort: true,
            sortFunc: onSortNumber
          },
          { dataField: 'uf', text: 'UF', sort: true },
          {
            dataField: 'anoDaAcaoFiscal',
            text: 'Ano da ação fiscal',
            sort: true
          },
          {
            dataField: 'decisaoAdministrativaDeProcedencia',
            text: 'Decisão administrativa de procedência',
            sort: true
          },
          { dataField: 'estabelecimento', text: 'Local', sort: true },
          {
            dataField: 'inclusaoNoCadastroDeEmpregadores',
            text: 'Inclusão no cadastro de empregadores',
            sort: true
          }
        ].map(item => ({ ...item, align: 'center', headerAlign: 'center' }))}
        data={mapWithRelationship({
          array: data || [],
          documentKey: 'cnpjCpf',
          nameKey: 'empregador',
          relateds
        }).map(item => {
          const id = hashObject(item)
          return {
            ...item,
            id,
            trabalhadoresEnvolvidos: parseInt(item.trabalhadoresEnvolvidos),
            rawDocument: item.cnpjCpf,

            document: isCypheredDocument(item.cnpjCpf) ? (
              item.cnpjCpf
            ) : (
              <a
                href={`?documento=${onlyNumbers(item.cnpjCpf)}`}
                target='_blank'
                rel='noopener noreferrer'
              >
                {formatDocument(item.cnpjCpf)}
              </a>
            )
          }
        })}
      >
        {props => (
          <>
            <div className='row'>
              <div className='col-12 text-lg-right'>
                <SearchBar {...props.searchProps} placeholder='Pesquisar' />
              </div>
            </div>
            <div className='row'>
              <div className='col-12'>
                <Table enablePagination {...props.baseProps} />
              </div>
            </div>
          </>
        )}
      </ToolkitProvider>
    </CustomWindow>
  )
}
